import React from 'react';
import * as ReactRouterDOM from 'react-router-dom';
import { useAppContext } from '../../context/AppContext.js';
import Brief from '../../components/Brief.js';
import { getWords } from '../../utils/get-words.js';
import { protect } from '../../utils/protect.js';

const BudgetCapitalTopPart1 = ReactRouterDOM.withRouter(function ({ budgetCapital }) {
  const { i18n, setError } = useAppContext();
  const words = getWords(i18n.code);

  return (
    <div>
      <div>
        <Brief
          fieldsDisposition="spaces-between"
          fieldsSize="large"
          fields={[
            {
              label: words.businessUnit,
              type: 'string',
              value: budgetCapital.businessUnitName,
              secondaryField: {
                type: 'string',
                value: budgetCapital.businessUnitCode,
              },
            },
            {
              label: words.subCategory,
              type: 'string',
              value: budgetCapital.subCategoryName,
              secondaryField: {
                type: 'string',
                value: budgetCapital.subCategoryCode,
              },
            },
            {
              label: words.superitem,
              type: 'string',
              value: budgetCapital.superitemName,
              secondaryField: {
                type: 'string',
                value: budgetCapital.superitemCode,
              },
            },
            {
              label: words.currency,
              type: 'string',
              value: budgetCapital.currencyName,
              secondaryField: {
                type: 'string',
                value: budgetCapital.currencyCode,
              },
            },
            {
              label: words.branch,
              type: 'string',
              value: budgetCapital.branchName,
              secondaryField: {
                type: 'string',
                value: budgetCapital.branchCode,
              },
            },
            {
              label: words.officer,
              type: 'string',
              value: protect(function ([firstName, lastName]) { return `${firstName} ${lastName}` }, [ budgetCapital.userFirstName, budgetCapital.userLastName ]),
              secondaryField: {
                type: 'string',
                value: budgetCapital.userUsername,
              },
            },
          ]}
        />
      </div>
    </div>
  );
})

export default BudgetCapitalTopPart1;
